import { React, i18n, inject, pr, ui, debug, george } from "aaa";
import { MessageScreen } from "../common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { GIGStore } from "./GIGStore";
import auth from "../../stores/AuthStore";
import { bindStr } from "../../i18n/util";
import { observer } from "mobx-react";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: GIGStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
@observer
export class GIGSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        if (this.props.store.isLoading()) {
            return (
                <george.LandingBackground>
                    <george.LoadingIndicator isLoading={this.props.store.isLoading()} height={ui.windowHeight} />
                </george.LandingBackground>
            );
        }

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                messageComponent={(
                    <i18n.FormattedHTMLMessage
                        id={(this.props.store.getEcommerceResponse && this.props.store.getEcommerceResponse.cie === "ACTIVE"
                            ? "gig.success.alreadyActivated"
                            : "gig.success")}
                    />
                )}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGSuccess.tsx